import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TextLocaValueProportional } from "../generic/text/TextLocaValueProportional";
export var ProductAmount = function (_a) {
    var item = _a.item, maxStorage = _a.maxStorage;
    var amountComponent = (React.createElement(TextLocaValueProportional, { available: item.amount, required: maxStorage }));
    if (item.storageLimit === -1) {
        amountComponent = React.createElement(NumberFormat, { amount: item.amount });
    }
    return (React.createElement("div", { className: "product-information__item" },
        React.createElement(Icon, { icon: IdIcon.StorageIcn, styleId: IdStyles.IconMedium }),
        React.createElement("div", { className: IdStyles.TextBoldAccent }, amountComponent)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/farm-management/ProductAmount.tsx
// module id = 2647
// module chunks = 3